import './TSCard.module.scss';

// The design system's Card: a raised panel with an optional icon, title and
// one action on the right. tone is 'sunken' (read-only) or 'brand' (the one
// thing to notice).
const TSCard = ({
  title,
  icon,
  action,
  tone,
  as: Tag = 'section',
  children,
}) => (
  <Tag className={`ts-card ${tone ? `ts-card--${tone}` : ''}`}>
    {(title || icon || action) && (
      <header className="ts-card__head">
        {icon && <span className="ts-card__icon">{icon}</span>}
        {title && <h3 className="ts-card__title">{title}</h3>}
        {action && <div className="ts-card__action">{action}</div>}
      </header>
    )}
    {children}
  </Tag>
);

export default TSCard;
